/**
 * Toggle the contact us form open
 */

import { toggleClass, toggleAttribute } from '../helpers';

const init = () => {
	const formToggle = document.querySelector('#js-toggle-contact-form');
	const form = document.querySelector('.csc-email-form');
	let formOpen = false;

	if (!formToggle) {
		return;
	}

	// Handle the visibility toggling
	function handleFormToggle() {
		toggleClass(document.body, '-email-form-open');
		toggleAttribute(formToggle, 'aria-expanded');
		toggleAttribute(form, 'aria-hidden');

		formOpen = !formOpen;
	}

	// Handle the an ESC close via the keyboard
	function escCloseForm(e) {
		if (formOpen) {
			if (27 === e.keyCode) {
				handleFormToggle();
			}
		}
	}

	formToggle.addEventListener('click', handleFormToggle);
	window.addEventListener('keydown', escCloseForm);
};

init();
